const i18n = {
  'en-US': {
    'invite.title.welcome': 'Welcome to join',
    'invite.title.team': 'CONN Networks',
    'invite.description': '{inviter} invited you to join {team}.',
    'invite.description.noInviter': 'You are invited to join {team}.',
    'invite.email': 'Email',
    'invite.username': 'User name',
    'invite.username.placeholder': 'Enter your user name (optional)',
    'invite.username.max': 'The user name cannot exceed 45 characters',
    'invite.password': 'Password',
    'invite.password.placeholder': 'Set your password',
    'invite.password.required': 'Please set your password',
    'invite.password.invalid': 'Must contain numbers, letters and special symbols (!@#$%^&*() and other non-space symbols) at the same time, at least 8 characters',
    'invite.password.confirm': 'Confirm Password',
    'invite.password.confirm.placeholder': 'Enter the password again',
    'invite.password.confirm.required': 'Please enter the password again',
    'invite.password.confirm.mismatch': 'The two passwords do not match',
    'invite.expired': 'The invitation expires at {time}',
    'invite.submit': 'Accept invitation and join',
    'invite.submit.loading': 'Submitting...',
    'invite.back': 'Back to sign in',
    'invite.success': 'Your account is ready, please sign in.',
    'invite.success.joined': 'This email already has an account and has been added to the team, please sign in.',
    'invite.failed': 'Failed to accept the invitation.',
    'invite.loading': 'Loading the invitation...',
    'invite.error.title': 'Invalid invitation link',
    'invite.error.token': 'The invitation link is invalid.',
    'invite.error.failed': 'Failed to load the invitation, please try again.'
  },
  'zh-CN': {
    'invite.title.welcome': '欢迎加入',
    'invite.title.team': 'CONN Networks',
    'invite.description': '{inviter} 邀请你加入 {team}。',
    'invite.description.noInviter': '邀请你加入 {team}。',
    'invite.email': '邮箱',
    'invite.username': '用户名',
    'invite.username.placeholder': '请输入用户名（可选）',
    'invite.username.max': '用户名不能超过 45 个字符',
    'invite.password': '密码',
    'invite.password.placeholder': '设置登录密码',
    'invite.password.required': '请设置密码',
    'invite.password.invalid': '密码需至少 8 位，且同时包含数字、字母和特殊符号（!@#$%^&*() 等非空格符号）',
    'invite.password.confirm': '确认密码',
    'invite.password.confirm.placeholder': '请再次输入密码',
    'invite.password.confirm.required': '请再次输入密码',
    'invite.password.confirm.mismatch': '两次输入的密码不一致',
    'invite.expired': '邀请有效期至 {time}',
    'invite.submit': '完成注册并加入',
    'invite.submit.loading': '提交中...',
    'invite.back': '返回登录',
    'invite.success': '账号已创建，请登录。',
    'invite.success.joined': '该邮箱已存在账号，已加入团队，请登录。',
    'invite.failed': '接受邀请失败',
    'invite.loading': '邀请信息加载中...',
    'invite.error.title': '邀请链接无效',
    'invite.error.token': '邀请链接无效',
    'invite.error.failed': '邀请信息加载失败，请稍后重试'
  }
};
export default i18n;